import { render, staticRenderFns } from "./VoucherConfirm.vue?vue&type=template&id=05d774a4"
import script from "./VoucherConfirm.vue?vue&type=script&lang=js"
export * from "./VoucherConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports